import { render, staticRenderFns } from "./CPopover.vue?vue&type=template&id=eae3c1b0&scoped=true"
import script from "./CPopover.vue?vue&type=script&lang=js"
export * from "./CPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae3c1b0",
  null
  
)

export default component.exports